/**
 * Élèves sans adresse e-mail (écoles primaires, collèges) : ils se connectent avec un identifiant
 * (`prenom.nom.4821`). Côté serveur, leur compte porte l’e-mail technique `<identifiant>@eleve.lyrra.invalid`
 * (domaine réservé, aucun e-mail n’y est envoyé). Cette adresse ne doit jamais être affichée :
 * utiliser `displayLoginOrEmail` partout où un e-mail d’utilisateur est montré.
 * Miroir de `apps/backend/src/utils/student-login.ts`.
 */
export const STUDENT_LOGIN_EMAIL_DOMAIN = 'eleve.lyrra.invalid';

const SUFFIX = `@${STUDENT_LOGIN_EMAIL_DOMAIN}`;

export function isSyntheticStudentEmail(email: string | null | undefined): boolean {
  return typeof email === 'string' && email.trim().toLowerCase().endsWith(SUFFIX);
}

/** Identifiant de connexion d’un élève sans e-mail, `null` pour une vraie adresse. */
export function studentLoginFromEmail(email: string | null | undefined): string | null {
  if (!isSyntheticStudentEmail(email)) return null;
  const value = String(email).trim().toLowerCase();
  return value.slice(0, value.length - SUFFIX.length);
}

/** Valeur à afficher : identifiant pour un élève sans e-mail, sinon l’adresse e-mail. */
export function displayLoginOrEmail(email: string | null | undefined): string {
  return studentLoginFromEmail(email) ?? String(email ?? '');
}

/** Saisie « e-mail ou identifiant » : un identifiant ne contient pas « @ ». */
export function isLoginIdentifierInput(value: string | null | undefined): boolean {
  const v = String(value ?? '').trim();
  return Boolean(v) && (!v.includes('@') || isSyntheticStudentEmail(v));
}
